import {User} from '../../Services/UserService';

export const INITIALISE = 'user/INIT';

interface InitAction {
  type: typeof INITIALISE;
  payload: User
}

export interface UserState {
  user: User;
}

export type UserActionTypes = InitAction;
